import { MuiThemeProvider } from "@material-ui/core/styles";
import React from "react";
import "react-app-polyfill/ie11";
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { applyMiddleware, compose, createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";
import registerServiceWorker from "./registerServiceWorker";
import rootReducer from "./rootReducer";
import Template from "./template";
import theme from "./theme";

//To enable Redux DevTools Extension
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const logger = createLogger();
let middlewares = [];

if (process.env.NODE_ENV === "development") {
  middlewares = [...middlewares, thunk, logger];
} else {
  middlewares = [...middlewares, thunk];
}

const persistConfig = {
  key: "root",
  storage
};

// const enHanceCreateStore = createStore(
//   composeEnhancers(applyMiddleware(thunk), reduxReset())
// );

const enHanceCreateStore = compose(applyMiddleware(...middlewares))(
  createStore
);

const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = enHanceCreateStore(persistedReducer);
export const persistor = persistStore(store);

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Template />
      </PersistGate>
    </Provider>
  </MuiThemeProvider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js